export class IkConstraintData {
    constructor() {
        this.boneNames = [];
        this.bendDirection = 1;
        this.mix = 1;
        this.isSpine = true;
        this.targetBoneIndex = -1;
        this.boneIndexs = [];
    }
}
